import styled from '@emotion/styled'
import { Image, Props as ImageProps } from 'app/components/Common/Image'
import { Rumble } from 'app/components/Icons'
import { Link } from 'gatsby'
import React, { memo, useRef, useState } from 'react'

export interface Props {
  id?: string
  title: string
  languageCode?: string
  languagePrefix?: string | null
  menuImage?: ImageProps
  url?: string
}

export const SecondaryMenuItem = memo(function SecondaryMenuItem({
  title,
  menuImage,
  url,
}: Props) {
  if (!title || !url) {
    return null
  }

  const imageEl = useRef<any>()
  const [isHover, setHover] = useState(false)

  return (
    <Anchor
      activeClassName="active"
      onMouseEnter={() => {
        setHover(true)
      }}
      onMouseLeave={() => {
        setHover(false)
      }}
      to={url}
    >
      <Inner>
        <Rumble />

        {title}
      </Inner>

      {menuImage ? (
        <Background ref={imageEl} className={isHover ? 'hover' : undefined}>
          <Image {...menuImage} />
        </Background>
      ) : null}
    </Anchor>
  )
})

const Background = styled.div`
  width: 100%;
  height: 100%;
  opacity: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  right: 0;
  transition: 0.2s linear;
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.variants.primaryDark};
    opacity: 0.85;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }

  @media (max-width: 1199px) {
    display: none;
  }
`

const Inner = styled.span`
  position: relative;
  transition: 0.4s ease-in-out;
  z-index: 2;
`

const Anchor = styled(Link)`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.variants.neutralLight5};
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
  transition: 0.4s ease-in-out;
  &.active {
    pointer-events: none;
    ${Inner} {
      opacity: 0.4;
    }
  }
  &:hover {
    ${Background} {
      opacity: 1;
    }
    ${Inner} {
      opacity: 0.4;
    }
  }

  svg {
    width: 0.25rem;
    height: 0.25rem;
    fill: ${({ theme }) => theme.colors.variants.neutralLight5};
    margin-right: 0.625rem;
    transform: translateY(-0.125rem);
  }

  @media (max-width: 1199px) {
    font-size: 2.25rem;
    font-weight: 300;
    line-height: 2.625rem;

    svg {
      display: none;
    }
  }
`
